// extracted by mini-css-extract-plugin
export var column = "order-options-module--column--aa315";
export var fieldset = "order-options-module--fieldset--b9754";
export var giftOptions = "order-options-module--gift-options--23ce4";
export var packagingOptions = "order-options-module--packaging-options--dcc85";
export var toggleButton = "order-options-module--toggleButton--836a3";